import Modal from '@/components/Modal';
import { IS_POS } from '@/utils/env';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequest } from '../api/hooks';

export type LogoutOption = {
  returnToUrl?: string;
  returnToCurrent?: boolean;
  needConfirm?: boolean;
  silent?: boolean;
};
export const useLogout = ({
  returnToCurrent = false,
  returnToUrl = '',
  needConfirm = false,
  silent = false,
}: LogoutOption = {}) => {
  const { send: reqLogout, loading } = useRequest(
    {
      method: 'get',
      url: `/auth/logout`,
    },
    { manual: true }
  );

  const logout = useCallback(
    ({
      params,
    }: {
      params?: { isActive?: boolean };
    } = {}) => {
      const onOk = () => {
        let loginUrl = `/login`;

        if (returnToCurrent) {
          loginUrl += `?return=${location.pathname}&${location.search.replace(/^\?/, '')}`;
        } else if (returnToUrl) {
          loginUrl += `?return=${returnToUrl}`;
        }

        if (silent) {
          return reqLogout({ params }).then();
        } else {
          return reqLogout({ params })
            .then(() => {
              // history.push(loginUrl);
              location.href = loginUrl;
            })
            .catch(() => {
              // history.push(loginUrl);
              location.href = loginUrl;
            });
        }
      };
      if (needConfirm && !silent) {
        Modal.confirm({
          title: '确认退出吗？',
          okText: '确认',
          cancelText: '取消',
          okButtonProps: {
            size: 'large',
            loading: loading,
          },
          cancelButtonProps: {
            size: 'large',
          },
          onOk,
        });
        return Promise.resolve();
      } else {
        return onOk();
      }
    },
    [reqLogout, history, needConfirm]
  );

  return { logout };
};

export const useOnHistoryBack = () => {
  const navigate = useNavigate();
  const [onBack, setOnBack] = useState<{ (e: PopStateEvent): void }>(null);

  const handler = (e: PopStateEvent) => {
    onBack && onBack(e);
  };

  useEffect(() => {
    window.addEventListener('popstate', handler, false);
    return () => {
      window.removeEventListener('popstate', handler, false);
    };
  }, [onBack]);

  return {
    setOnBackListener: (fn: { (e: PopStateEvent): void }) => {
      setOnBack(() => fn);
    },
    navigate,
  } as const;
};

export const useBackToIndexOnPos = () => {
  const { setOnBackListener, navigate } = useOnHistoryBack();
  useEffect(() => {
    if (IS_POS) {
      setOnBackListener(e => {
        e.preventDefault();
        navigate(`/POS/index`);
      });
    }
  }, []);
};
